import React, { forwardRef } from "react";
import { Camera, CameraOff, Mic, MicOff, Video } from "lucide-react";


const VideoPreview = forwardRef(
  (
    {
      cameraEnabled,
      micEnabled,
      recording,
      onToggleCamera,
      onToggleMic,
      theme,
    },
    ref
  ) => (
    <div className={`${theme.card} rounded-xl shadow-lg border p-6`}>
      <div className="flex items-center justify-between mb-4">
        <h2 className={`text-lg font-semibold ${theme.text} flex items-center`}>
          <Video className="h-5 w-5 mr-2" />
          Video Preview
        </h2>
        <div className="flex space-x-2">
          <button
            onClick={onToggleCamera}
            className={`p-2 rounded-lg transition-all duration-200 ${
              cameraEnabled
                ? "bg-blue-100 text-blue-600"
                : "bg-gray-100 text-gray-600"
            }`}
          >
            {cameraEnabled ? (
              <Camera className="h-4 w-4" />
            ) : (
              <CameraOff className="h-4 w-4" />
            )}
          </button>
          <button
            onClick={onToggleMic}
            className={`p-2 rounded-lg transition-all duration-200 ${
              micEnabled
                ? "bg-blue-100 text-blue-600"
                : "bg-gray-100 text-gray-600"
            }`}
          >
            {micEnabled ? (
              <Mic className="h-4 w-4" />
            ) : (
              <MicOff className="h-4 w-4" />
            )}
          </button>
        </div>
      </div>

      <div className="relative bg-gray-900 rounded-xl overflow-hidden aspect-video shadow-inner">
        <video
          ref={ref}
          autoPlay
          muted
          className="w-full h-full object-cover"
        />
        {!cameraEnabled && (
          <div className="absolute inset-0 flex items-center justify-center bg-gray-800">
            <div className="text-center text-white">
              <CameraOff className="h-12 w-12 mx-auto mb-2 opacity-50" />
              <p className="text-sm opacity-75">Camera disabled</p>
            </div>
          </div>
        )}
        {recording && (
          <div className="absolute top-4 right-4 flex items-center bg-red-600 text-white px-3 py-1 rounded-full text-sm font-medium">
            <div className="w-2 h-2 bg-white rounded-full mr-2 animate-pulse"></div>
            REC
          </div>
        )}
      </div>
    </div>
  )
);

export default VideoPreview;
